// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const IndicatorIcon = (props: IconProps) => (
  <Icon viewBox="0 0 3 10" fill="none" {...props}>
    <path d="M1.25781 1V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);
